import PropTypes from "prop-types";
import { cn } from "@shared/lib/utils";

/**
 * EmptyState component for displaying empty states with optional icon and actions
 */
function EmptyState({ icon, title, description, action, className = "" }) {
  return (
    <div className={cn("p-8 text-center", className)}>
      {icon && <div className="mb-4 flex justify-center">{icon}</div>}

      {title && (
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
          {title}
        </h3>
      )}

      {description && (
        <p className="text-gray-500 dark:text-gray-400 mb-4">{description}</p>
      )}

      {action && <div className="flex justify-center">{action}</div>}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string,
};

export default EmptyState;
